/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFromLocalStorage } from '../../../../../components/helper/authorizationHelper';
import { getAsync } from '../../../../../components/helper/axiosHelper';
import { handleFileDownload } from '../../../../../libs';
import { DetailAccordion } from '../../sd/DetailAccordion';
import { PageHitCountApi } from '../../../../../shared/Helper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import '../gwaStyles.css';

export default function UpdateGWARegister() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [countryAPIData, setCountryAPIData] = useState([]);
  const [limitRequest, setLimitRequest] = useState(true);
  const [nationalityAPIData, setNationalityAPIData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [mediaData, setMediaData] = useState([]);
  const [epUserID, setEpUserID] = useState(null);

  const location = useLocation();
  const { id } = location.state || {};
  // const { id } = useParams();

  const headings = ['Donor ID', 'Profile Picture', 'License'];
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token && !epUserID) {
      navigate('/donorLogin');
    }
  };

  const getCountries = async () => {
    await getAsync('Utilities/GetCountryList')
      .then((response) => {
        setCountryAPIData(response?.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getNationality = async () => {
    await getAsync('Utilities/GetNationalityList')
      .then((response) => {
        setNationalityAPIData(response?.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID !== null) {
      isLogin();
      getData(id);
      PageHitCountApi(location.pathname, epUserID);
    }

    getCountries();
    getNationality();
  }, [epUserID]);

  //GET dataById for upadate

  const getData = async (id) => {
    setIsLoading(true);
    await getAsync('GWAService/GetGWAServiceByEPUserId', { id: id }, 'application/json')
      .then((response) => {
        // setNationalityName(response?.data[0].residentCountryName);
        // if (response?.data[0].gwaTypeID == 1) {
        // }
        // setCountryName(response?.data[0]?.countryName);
        // setWebsite(response?.data[0]?.website);
        // // setAccountLink(response?.data[0]?.accountHandelMappingList[0].accountName);
        // setRegReason(response?.data[0]?.regReason);
        // setGwaTypeID(response?.data[0]?.gwaTypeID);
        // //setAccountName(response?.data[0]?.accountHandelMappingList[0].siteName);
        // setAccountHandelMappingList(response?.data[0]?.accountHandelMappingList);
        // setDonerIDMedia(response?.data[0]?.archiveMediaModelList);
        // console.log('v:', response?.data[0]?.archiveMediaModelList);
        // setAllowedFileExtensions(donerIDMedia?.data)
        setMainData(response?.data[0]);
        setMediaData(response?.data[0]?.archiveMediaModelList);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const handleDocLoad = async (e) => {
    e.preventDefault();
    await getData(id);
    setLimitRequest(false);
  };

  const foundNationality = nationalityAPIData?.find(
    (element) => element?.settingsNationalityID == mainData?.nationalityID,
  );
  const foundCountry = countryAPIData?.find((element) => element?.countryID == mainData?.residentCountryID);
  return (
    <div className="container-fluid pt-12 ">
      <div className="row justify-center py-5">
        <div className="col-xl-11">
          <form>
            <div className="card ">
              <div style={{ textAlign: 'center' }} className="card-header">
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen">
                  {t('Good Will Ambassador Register View')}{' '}
                </h3>
              </div>
              <hr />
              {isLoading ? (
                <LoadingAnimation />
              ) : (
                <div className="card-body ">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Personal Details')}</h2>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography></Typography>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              {t('User Type')} <span className="errmsg">*</span>
                            </label>
                            <br />
                            <label style={{ margin: '10px' }} className="text-gray-700 p-2  text-pretty text-sm">
                              <input
                                disabled
                                className="peer relative  cursor-not-allowed focus:ring-4 focus:ring-customgreen appearance-none rounded-full border border-customgreen transition-all
                                before:content[''] before:absolute before:top-2/4 before:left-2/4 before:block before:h-5 before:w-5 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-customgreen before:opacity-0 before:transition-opacity
                                checked:border-none checked:bg-customgreen checked:before:bg-white "
                                style={{
                                  marginRight: '5px',
                                  backgroundColor: 'lightgray',

                                  cursor: 'no-drop',
                                }}
                                type="radio"
                                // defaultChecked={ mainData?.gwaTypeID == 1 ? true : false }
                                defaultChecked={mainData?.gwaTypeID == 1 ? true : false}
                                name="userType"
                                value={mainData?.gwaTypeID}
                              />
                              {t('Institute')}
                            </label>
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              <input
                                disabled
                                className="peer relative  cursor-not-allowed focus:ring-4 focus:ring-customgreen appearance-none rounded-full border border-customgreen transition-all
                                before:content[''] before:absolute before:top-2/4 before:left-2/4 before:block before:h-5 before:w-5 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-customgreen before:opacity-0 before:transition-opacity
                                checked:border-none checked:bg-customgreen checked:before:bg-white "
                                style={{
                                  marginRight: '5px',
                                  cursor: 'no-drop',
                                }}
                                type="radio"
                                name="userType"
                                defaultChecked={mainData?.gwaTypeID == 2 ? true : false}
                                value={mainData?.gwaTypeID}
                              />
                              {t('Personal')}
                            </label>
                          </div>
                        </div>

                        {mainData?.gwaTypeID == 2 && (
                          <div className="col-lg-6 mb-4">
                            <div className="form-group">
                              <label className="text-gray-700 p-2  text-pretty text-sm">
                                {t('Workplace')}
                                <span className="errmsg">*</span>
                              </label>
                              <input
                                value={mainData?.workPlace}
                                disabled
                                style={{
                                  cursor: 'no-drop',
                                }}
                                type="text"
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-lg-6 mb-4">
                          <div className="form-group">
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              {t('Nationality')} <span className="errmsg">*</span>
                            </label>
                            {foundNationality && (
                              <input
                                value={isActive ? foundNationality.nationality_t : foundNationality.nationality_eng}
                                disabled
                                type="text"
                                style={{
                                  cursor: 'no-drop',
                                }}
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                              />
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label className="text-gray-700 p-2  text-pretty text-sm">
                              {t('Resident Country')}
                              <span className="errmsg">*</span>
                            </label>
                            {foundCountry && (
                              <input
                                value={isActive ? foundCountry.ar_SA : foundCountry?.en_US}
                                disabled
                                type="text"
                                style={{
                                  cursor: 'no-drop',
                                }}
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  <br />

                  <DetailAccordion
                    limitRequest={limitRequest}
                    handleDocLoad={handleDocLoad}
                    mediaData={mediaData}
                    handleFileDownload={handleFileDownload}
                    title={'Document Details'}
                    header={headings}
                  />
                  <br />

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Account Details')}</h2>
                    </AccordionSummary>
                    <AccordionDetails className="px-4">
                      <div className="row ">
                        <div className=" mb-4 px-0">
                          <div className="form-group">
                            <label className="text-gray-700 p-2  text-pretty text-sm">{t('Website')}</label>
                            <input
                              value={mainData?.website}
                              disabled
                              type="text"
                              className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row ">
                        <table className="table-fixed w-full table-bordered">
                          <thead className="text-gray-200 uppercase bg-customgreen">
                            <tr>
                              <td className="py-1 border capitalize   p-2 text-white  text-pretty">{t('sNo')}</td>
                              <td className="py-1 border   p-2 text-white  capitalize text-pretty">
                                {t('Account Name')}
                              </td>
                              <td className="py-1 border   p-2 text-white  capitalize text-pretty">
                                {t('Account Title')}
                              </td>
                            </tr>
                          </thead>
                          {mainData?.accountHandelMappingList?.map((item, index) => (
                            <tbody className="text-gray-700" key={index}>
                              <tr>
                                <td className="py-1  p-2">{index + 1}</td>
                                <td className="py-1   p-2">{item.accountName}</td>
                                <td className="py-1   p-2">{t(`${item.siteName}`)}</td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  <br />

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Extra')}</h2>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography></Typography>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="text-gray-700 p-2  text-pretty text-sm">
                            {t('Reason')} <span className="errmsg">*</span>
                          </label>
                          <textarea
                            style={{
                              cursor: 'no-drop',
                              height: '100px',
                            }}
                            value={mainData?.regReason}
                            className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            minLength="1"
                            maxLength="500"
                            disabled
                          />
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}

              <div className="card-footer ">
                <Link
                  to={'/GWARegisterList'}
                  className="text-white w-32  bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                >
                  {t('Back')}
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
